<template>
  <div class="row mt-4 mb-4">
    <div class="col-12">
      <div class="float-right mb-3 mb-sm-3 mb-md-0">
        <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
        >
          Añadir
        </button>
      </div>
    </div>
    <div class="col-12">
      <app-table :id="tableId" :options="options" @action="getListAction"/>
      <pending-process-modal
          v-if="isAddEditModalActive"
          :table-id="tableId"
          :selected-url="selectedUrl"
          modalTitle="Añadir proceso disponible"
          editModalTitle="Editar proceso"
          :dataInfo="dataInfo"
          @close-modal="closeAddEditModal"
      />
      <app-confirmation-modal
          v-if="deleteConfirmationModalActive"
          modal-id="modal-delete"
          @confirmed="confirmed"
          @cancelled="cancelled"
          title="Confirmación"
          message="¿Desea eliminar este registro?"
      />
    </div>
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import {TableHelpers} from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      rowData: {},
      options: {
        url: `accreditations/applications_historical_data/vigilances/${this.$store.state.accreditation.id}`,
        name: "",
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "pending-process-modal",
            modalId: "add-edit-modal-pending",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "delete",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      inputs: {includes_sampling: 0},
      tableId: "pending-process-table",
      dataInfo: {
        maintenance_date: new Date(),
        type_acc: "",
        id: null
      }
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#add-edit-modal-pending").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `accreditations/applications_historical_data/vigilances/${rowData.id}`;
        this.dataInfo = {
          maintenance_date: new Date(this.rowData.maintenance_date.toString().concat('T00:00:00')),
          type_acc: this.rowData.accreditation_type_id,
          id: rowData.id
        }
        this.openAddEditModal();
      }
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      let url = `accreditations/applications_historical_data/vigilances/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
          .then((response) => {
            this.deleteLoader = false;
            $("#delete").modal("hide");
            this.cancelled();
            this.$toastr.s(this.$t("deleted_success"));
          })
          .catch(({error}) => {
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.dataInfo = {
        maintenance_date: new Date(),
        type_acc: ""
      }
      this.selectedUrl = "";
    },

    data() {
      this.preloader = true;
      this.axiosGet(
          `/accreditations/applications/form/${this.$store.state.accreditation.id}`
      )
          .then((response) => {
            if (response.status == 200 && response.data) {
              this.inputs = {
                id: response.data.id,
                includes_sampling: response.data.includes_sampling,
              };
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.preloader = false;
          });
    },
  },
}
</script>

<style>

</style>